import { cx } from 'utils/cx'
import type { CarouselHeader, CarouselVariants } from '../../types'
import { Action } from '../Action/Action'
import { Arrows } from '../Arrows/Arrows'
import { Header } from '../Header/Header'

import styles from './HeaderWrapper.module.scss'

interface HeaderWrapperProps {
	readonly headerProps: CarouselHeader
	readonly variant: CarouselVariants
}

export function HeaderWrapper({ headerProps, variant }: HeaderWrapperProps) {
	const { action } = headerProps
	return (
		<div className={cx(styles.wrapper, styles[`carouselType${variant}`])}>
			<Header {...headerProps} />
			<div className={styles.actions}>
				<Arrows />
				{action && <Action {...action} />}
			</div>
		</div>
	)
}
